import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name", "tagName"];
import { Block } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Title = props => {
  var {
      keyname = 'title',
      name,
      tagName = 'h1'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var key = keyname || name;
  if (!elmProps.children) {
    elmProps.children = 'Member Login';
  }
  return /*#__PURE__*/_jsx(Block, _extends({
    tagName: tagName
  }, elmProps, {
    keyname: key
  }));
};
Title.displayName = 'Login.Title';